import { Select, Text as CoreText } from '@hopskipdrive/react-components';
import { colorPalette, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const StyledTable = styled.table`
  font-weight: 300;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  tr {
    border: 1px solid ${colorPalette.neutral80};
  }
  th {
    padding: 4px 4px;
    text-align: left;
  }
  td {
    padding: 4px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledSelect = styled(Select)`
  max-width: 50%;
  ${variables.mediaQuery.lessThan('desktop')`
  max-width: 100%;
  `}
`;

export const Text = styled(CoreText)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
